module.exports = __webpack_public_path__ + "static/icon-1c7f12c23df520c877c44484d24bf7d0.png";